import { Popover, Typography } from "antd";
import { isEmpty, isFunction } from "lodash";
import React, { useEffect, useState } from "react";
import {
  RISK_SCORE_DOC_LINK,
  getRiskScoreDisplayFormula,
  getRiskScorePopoverTitleProps,
} from "utils/riskScoreUtil";
import { LoadingIcon } from "./Icons";
import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";

const { Link: HyperLink } = Typography;

export default function FindingRiskScorePopover({ finding: findingFromProp, children, fetchFinding, showFindingLink, wrapSpan = true, placement = "top" }) {
  const [finding, setFinding] = useState(findingFromProp);
  const [visible, setVisible] = useState(false);
  const {riskScoreRange} = useGlobalSettingsContext();

  useEffect(() => {
    setFinding(findingFromProp);
  }, [findingFromProp])

  useEffect(() => {
    if(!visible || !isEmpty(finding)){
      return;
    }
    if(!isFunction(fetchFinding)){
      return;
    }
    const { promise, cancel } = fetchFinding();
    promise.then(r => setFinding(r.content[0]));
    return cancel;
  }, [finding, visible, fetchFinding]);

  const { riskScore } = finding || {};
  const popoverTitleProps = getRiskScorePopoverTitleProps(
    riskScore,
    true,
    riskScoreRange,
    true
  );
  return (
    <Popover
      align={{ offset: [0, 6] }}
      onVisibleChange={setVisible}
      visible={visible}
      placement={placement}
      content={
        isEmpty(finding) ? (
          <div className="text-center">
            <LoadingIcon />
          </div>
        ) : (
          <div>
            <Typography.Text
              strong
              className={`${popoverTitleProps.titleStyle}-text m-b-xs`}
            >
              {popoverTitleProps.title}
            </Typography.Text>
            {getRiskScoreDisplayFormula(finding)}
            {showFindingLink ? (
              <div>
                Riskiest finding is{" "}
                <HyperLink
                  target="_blank"
                  href={`#/findings/${finding.id}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  {finding.id}
                </HyperLink>
              </div>
            ) : null}
            <div className="d-flex justify-content-flex-end tag-tooltip-doc-link">
              {RISK_SCORE_DOC_LINK}
            </div>
          </div>
        )
      }
    >
      {
        wrapSpan
        ?
        <span>{children}</span>
        :
        children
      }
    </Popover>
  );
}
